export default "__VITE_ASSET__df38a73d__"